import React, { useState } from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import './Accordion.scss';

interface AccordionProps {
  title: React.ReactNode;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  headerRight,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="accordion">
      <button className="accordion-header" onClick={() => setIsOpen((prev) => !prev)}>
        <span className="accordion-title">{title}</span>
        <span className="accordion-header-right">
          {headerRight}
          <FontAwesomeIcon
            glyph={isOpen ? 'chevron-up' : 'chevron-down'}
            weight="light"
            size="small"
          />
        </span>
      </button>
      {isOpen && <div className="accordion-content">{children}</div>}
    </div>
  );
};

export default Accordion;
